// Firebase analytics implementation
export enum EVENT {
  UE_LOGOUT = 'ue_logout',
  SV_LOGOUT_CONFIRMATION = 'sv_logout_confirmation',
  UE_LOGOUT_CONFIRM = 'ue_logout_confirm',
  UE_LOGOUT_CANCEL = 'ue_logout_cancel',
  SV_HOME = 'sv_home',
  UE_VIEW_SEARCH_NEW = 'ue_view_search_new',
  UE_VIEW_SEARCH_RECENT = 'ue_view_search_recent',
  UE_VIEW_SEARCH_FAVORITE = 'ue_view_search_favorite',
  UE_VIEW_WATCHED_LOADS = 'ue_view_watched_loads',
  UE_SEARCH_RESULTS = 'ue_search_results',
  UE_MARK_FAVORITE = 'ue_mark_favorite',
  UE_MARK_UNFAVORITE = 'ue_mark_unfavorite',
  UE_MARK_WATCH = 'ue_mark_watch',
  UE_MARK_UNWATCH = 'ue_mark_unwatch',
  UE_CHANGE_PASSWORD = 'ue_change_password',
  SV_CHANGE_PASSWORD_CONFIRMATION = 'sv_change_password_confirmation',
  UE_CHANGE_PASSWORD_CONFIRM = 'ue_change_password_confirm',
  UE_CHANGE_PASSWORD_CANCEL = 'ue_change_password_cancel',
  UE_FEEDBACK = 'ue_feedback',
  UE_FEEDBACK_SUBMIT = 'ue_feedback_submit',
  UE_FEEDBACK_FAILURE = 'ue_feedback_failure',
  SV_DEVICE_INFO = 'sv_device_info',
  UE_DEVICE_INFO = 'ue_device_info',
  UE_SEARCH_RELOAD = 'ue_search_reload',
  SV_VIEW_LOAD_DETAILS = 'sv_view_load_details',
  SV_VIEW_LOAD_RATE = 'sv_view_load_rate',
  SV_VIEW_LOAD_MAP = 'sv_view_load_map',
  SV_VIEW_LOAD_COMMODITIES = 'sv_view_load_commodities',
  SV_VIEW_LOAD_COMMODITIES_ADDITIONAL = 'sv_view_load_commodities_additional',
  SV_VIEW_LOAD_SERVICES = 'sv_view_load_services',
  UE_MY_PROFILE = 'ue_my_profile',
  UE_MY_PROFILE_EDIT = 'ue_my_profile_edit',
  UE_MY_PROFILE_EDIT_REDIRECTION = 'ue_my_profile_edit_redirection',
  UE_BOOK_LOAD_NOW = 'ue_book_load_now',
  SV_PRE_BOOK_NOW_MODAL = 'sv_pre_book_now_modal',
  SV_VIEW_BOOK_NOW_RATE = 'sv_view_book_now_rate',
  UE_BOOK_NOW_FAILURE = 'ue_book_now_failure',
  SV_LOAD_BOOK_FAIL = 'sv_load_book_fail',
  UE_BOOK_NOW_SUCCESS = 'ue_book_now_success',
  UE_LOAD_RATE_ACCEPT = 'ue_load_rate_accept',
  UE_LOAD_RATE_DECLINE = 'ue_load_rate_decline',
  UE_PRE_BOOK_NOW_ACCEPTANCE = 'ue_pre_book_now_acceptance',
  UE_PRE_BOOK_NOW_CANCELLATION = 'ue_pre_book_now_cancellation',
  UE_LOAD_BOOK_DISMISS = 'ue_load_book_dismiss',
  UE_LOAD_BOOK_UPDATE_NOW = 'ue_load_book_update_now',
  UE_LOAD_BOOK_REFRESH_RESULTS = 'ue_load_book_refresh_results',
  UE_NAT_NAL = 'ue_nat_nal',
  SV_VIEW_NAT_NAL = 'sv_view_nat_nal',
  UE_NAT_NAL_LAST_SHIPMENT = 'ue_nat_nal_last_shipment',
  UE_NAT_NAL_REFRESH = 'ue_nat_nal_refresh',
  UE_NAT_NAL_RELOAD = 'ue_nat_nal_reload',
  UE_NAT_NAL_EDIT = 'ue_nat_nal_edit',
  SV_VIEW_NAT_NAL_EDIT = 'sv_view_nat_nal_edit',
  UE_NAT_NAL_EDIT_SAVE = 'ue_nat_nal_edit_save',
  UE_NAT_NAL_EDIT_SAVE_SUCCESS = 'ue_nat_nal_edit_save_success',
  UE_NAT_NAL_EDIT_SAVE_FAILURE = 'ue_nat_nal_edit_save_failure',
  UE_LOAD_RATE_INSERT_SHIPMENT = 'ue_load_rate_insert_shipment',
  SV_VIEW_BOOK_NOW_LOAD_SEQUENCE = 'sv_view_book_now_load_sequence',
  UE_LOAD_SEQUENCE_ACCEPT = 'ue_load_sequence_accept',
  UE_LOAD_SEQUENCE_CANCEL = 'ue_load_sequence_cancel',
  UE_SUPPORT = 'ue_support',
  SV_VIEW_MYLOADS = 'sv_view_myloads',
  SV_VIEW_DRIVER_ASSIGNED = 'sv_view_driver_assigned',
  SV_VIEW_IN_TRANSIT = 'sv_view_in_transit',
  UE_LOAD_BOOK_INSERT_SHIPMENT = 'ue_load_book_insert_shipment',
  UE_FINANCIAL_INFO = 'ue_financial_info',
  UE_HORIZON_NAVIGATION = 'ue_horizon_navigation',
  UE_PREFERENCES = 'ue_preferences',
  UE_PREFERENCES_SAVE = 'ue_preferences_save',
  UE_PREFERENCES_SAVE_SUCCESS = 'ue_preferences_save_success',
  UE_PREFERENCES_SAVE_FAIL = 'ue_preferences_save_fail',
  UE_CONFIRMED_APPOINTMENTS_SWITCH = 'ue_confirmed_appointments_switch',
  UE_STANDARD_NETWORK_SWITCH = 'ue_standard_network_switch',
  UE_ADVANCE_SEARCH = 'ue_advance_search',
  SV_LOAD_BOOK_SUCCESS = 'sv_load_book_success',
  UE_LOAD_BOOK_RELOAD_NOW = 'ue_load_book_reload_now',
  UE_LOAD_BOOK_GO_HOME = 'ue_load_book_go_home',
  UE_ADVANCED_FILTERS_TOGGLE = 'ue_advanced_filters_toggle',
  UE_ADVANCED_FILTERS_DETAILS = 'ue_advanced_filters_details',
  UE_ADVANCED_FILTERS_RESET = 'ue_advanced_filters_reset',
  UE_ADVANCED_FILTERS_ACCEPT = 'ue_advanced_filters_accept',
  UE_ADVANCED_FILTERS_CANCEL = 'ue_advanced_filters_cancel',
}

export enum SCREEN {
  HOME = 'home',
  SEARCH = 'search',
  MORE_MENU = 'more',
  TOP_MENU_WEB = 'top_menu',
  MY_PROFILE_EDIT = 'my_profile_edit',
  LOGOUT_CONFIRMATION = 'logout_confirmation',
  CHANGE_PASSWORD_CONFIRMATION = 'change_password_confirmation',
  FEEDBACK_MODAL = 'feedback_modal',
  DEVICE_INFO_MODAL = 'device_info_modal',
  PROFILE = 'profile',
  LOAD_DETAILS = 'load_details',
  MANAGE_MENU = 'manage',
  PRE_BOOK_NOW_MODAL = 'pre_book_now_modal',
  LOAD_DETAILS_RATE = 'load_details_rate',
  LOAD_BOOK_FAIL = 'load_book_fail',
  SAMEDAY_PICKUP_MODAL = 'sameday_pickup_modal',
  LEFT_MENU = 'left_menu',
  TAB_BAR = 'tab_bar',
  NAT_NAL = 'nat_nal',
  NAT_NAL_EDIT = 'nat_nal_edit',
  LOAD_DETAILS_LOAD_SEQUENCE = 'load_details_load_sequence',
  SUPPORT = 'support',
  MYLOADS = 'myloads',
  MYLOADS_DRIVER_ASSIGNED = 'myloads_driver_assigned',
  MYLOADS_IN_TRANSIT = 'myloads_in_transit',
  FINANCIAL_INFO = 'financial_info',
  HORIZON = 'horizon',
  LEFT_NAV_ITEM = 'left_nav_item',
  PREFERENCES = 'preferences',
  MY_PROFILE = 'my_profile',
  LOAD_BOOK_THANK_YOU = 'load_book_thank_you',
  ADVANCED_FILTERS_DETAILS = 'advanced_filters_details',
}

export enum LEAD {
  LOGIN_SUCCESS = 'login_success',
  LEFT_NAV = 'left_nav',
  TAB_BAR = 'tab_bar',
  MORE = 'more',
  MY_PROFILE = 'my_profile',
  TOP_MENU_WEB = 'top_menu',
  MANAGE_MENU = 'manage',
  NEW = "new",
}

export enum TAB {
  NEW = 'new',
  RECENT = 'recent',
  FAVORITE = 'favorite',
  WATCHED = 'watched',
}
export enum MODE {
  ADVANCE_SEARCH_ON = 'advance_search_on',
  ADVANCE_SEARCH_OFF = 'advance_search_off',
  ADVANCED_FILTERS_ON = "advanced_filters_on ",
  ADVANCED_FILTERS_OFF = "advanced_filters_off ",
}
